export const CardForm = ({handleCreateCard, cardTitle, setCardTitle, list, setActiveListId}) => {
    return (
        <form
            className="boardPage__createList"
            style={{
                width: "unset",
                minWidth: "unset",
                padding: "0",
            }}
            onSubmit={(e) => handleCreateCard(e, list.id)}
        >
            <input
                type="text"
                placeholder="Enter card title..."
                value={cardTitle}
                onChange={(e) => setCardTitle(e.target.value)}
                autoFocus
            />

            <div className="boardPage__createActions">
                <button type="submit">Add card</button>
                <button
                    type="button"
                    onClick={() => {
                        setActiveListId(null);
                        setCardTitle("");
                    }}
                >
                    Cancel
                </button>
            </div>
        </form>
    )
}